export default __webpack_public_path__ + "static/820-c764232a83873dcd3bc3e939ee54545b.gif";